import React from "react";
import SiteDocumentation from "./SiteDocumentation";

export default function XMQ_doc_mosquitto_import() {
    return <SiteDocumentation page="mosquitto-import"/>;
}
